import { useMemo } from "react";
import { useNoteTypeCatalog } from "./useNoteTypes";
import { buildNoteGroupIndex } from "../../noteTypeGroup.util";
/**
 * The note-type -> department group lookup for the signed-in user's organization.
 *
 * Backed by the same cached `noteTypeCatalog` query the permitted-note-types autocomplete uses, so
 * every notes surface on the page shares one request. The catalogue endpoint is available to any
 * authenticated user, not only admins — a restaurant user has to be able to read the badges too.
 */
export var useNoteGroupIndex = function () {
    var catalog = useNoteTypeCatalog();
    return useMemo(function () { return buildNoteGroupIndex(catalog); }, [catalog]);
};
